import styled from 'styled-components';
import { Tooltip } from 'ui/tooltip';
import { spacing } from 'ui/theme';

export const StyledTooltip = styled(Tooltip)`
  padding-top: ${spacing.quarter};
`;
